var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.318 25.743h21.364c2.04 0 3.318-1.47 3.318-3.318 0-.558-.136-1.116-.435-1.632L16.863 1.686a3.273 3.273 0 0 0-5.725 0L.447 20.806C.164 21.323 0 21.866 0 22.424c0 1.85 1.278 3.319 3.318 3.319m10.689-9.084c-.707 0-1.088-.408-1.102-1.13l-.19-7.397c-.014-.72.517-1.237 1.278-1.237.748 0 1.306.53 1.292 1.25l-.19 7.385c-.014.734-.408 1.129-1.088 1.129m0 4.555c-.803 0-1.51-.653-1.51-1.455 0-.816.694-1.469 1.51-1.469.83 0 1.523.64 1.523 1.47 0 .815-.707 1.454-1.523 1.454"
  })));
};
export default SvgError;